import React, { useState, useEffect, useRef } from "react";

// material ui
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
// validator
import isNumeric from "validator/lib/isNumeric";
import useStyles from "./styles";
import { is } from "date-fns/locale";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import InfoButton from "../../../../../components/InfoButton";
import moment from "moment/moment";

function SubForm01({
  id,
  setValue,
  saveValueJump,
  saveValue,
  value,
  no_kk,
  handleBackSub,
  isSubmitting,
  keluarga,
}) {
  //console.log("VALUEEEEEEEEEEEEEE : ", value)
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const classes = useStyles();
  const [error, setError] = useState({});

  //tambahan
  const [kelahiran, setKelahiran] = useState(value.kelahiran || 0);
  const [lahirHidupLaki, setLahirHidupLaki] = useState(
    value.lahir_hidup_laki_laki || 0
  );
  const [lahirHidupPerempuan, setLahirHidupPerempuan] = useState(
    value.lahir_hidup_perempuan || 0
  );
  const [masihHidupLaki, setMasihHidupLaki] = useState(
    value.masih_hidup_laki_laki || 0
  );
  const [masihHidupPerempuan, setMasihHidupPerempuan] = useState(
    value.masih_hidup_perempuan || 0
  );

  useEffect(() => {
    setError({});
  }, []);

  //console.log("value ", value)

  const pertanyaan = "Sudah berapa kali Ibu melahirkan ?";

  const handleChange = (e) => {
    if (e.target.type === "number" && parseInt(e.target.value) < 0) {
      return false;
    }

    if (e.target.type === "number" && e.target.value.length > 2) {
      return false;
    }

    if (e.target.type === "number" && e.target.value > 20) {
      return false;
    }

    setValue(e);

    setError({
      ...error,
      [e.target.name]: "",
    });

    // setSomethingChange(true)

    // console.log("value kelahiran ", value.kelahiran)
    // console.log("e kelahiran ", e.target.name)

    switch (e.target.name) {
      case "kelahiran":
        setKelahiran(e.target.value);
        break;
      case "lahir_hidup_laki_laki":
        setLahirHidupLaki(e.target.value);
        break;
      case "lahir_hidup_perempuan":
        setLahirHidupPerempuan(e.target.value);
        break;
      case "masih_hidup_laki_laki":
        setMasihHidupLaki(e.target.value);
        break;
      case "masih_hidup_perempuan":
        setMasihHidupPerempuan(e.target.value);
        break;
      default:
        break;
    }
  };

  //save onchange value
  useEffect(() => {
    // console.log("Kelahiran => ",kelahiran)
    // console.log("idup laki => ",lahirHidupPerempuan)
    // console.log("idup cw => ",lahirHidupPerempuan)
    // console.log("mati laki => ",matiLaki)
    // console.log("mati cw => ",matiPerempuan)

    let normalizeValue = {
      _id: `${no_kk}${id}`,
      Pertanyaan: pertanyaan,
      Jawaban_H1: kelahiran,
      Jawaban_H2: 0,
      Jawaban_HDate1: "",
      Jawaban_HDate2: "",
      No_Pertanyaan: 1,
      No_KK: no_kk,
      answer: [
        {
          _id: `${no_kk}${id}01`,
          No_Jawaban: 1,
          // Jawaban_D1: parseInt(lahirHidupLaki),
          // Jawaban_D2: parseInt(lahirHidupPerempuan),
          Jawaban_D1: lahirHidupLaki,
          Jawaban_D2: lahirHidupPerempuan,
          Jawab_D3: 0,
          Jawab_D4: 0,
          pilihankb: 0,
          Lainnya: "",
        },
        {
          _id: `${no_kk}${id}02`,
          No_Jawaban: 2,
          // Jawaban_D1: parseInt(masihHidupLaki),
          // Jawaban_D2: parseInt(masihHidupPerempuan),
          Jawaban_D1: masihHidupLaki,
          Jawaban_D2: masihHidupPerempuan,
          Jawab_D3: 0,
          Jawab_D4: 0,
          pilihankb: 0,
          Lainnya: "",
        },
      ],
    };
    if (value._rev) {
      normalizeValue._rev = value._rev;
    }

    //console.log("save onchange => ", normalizeValue)
    saveValueJump(normalizeValue);
  }, [
    kelahiran,
    lahirHidupLaki,
    lahirHidupPerempuan,
    masihHidupLaki,
    masihHidupPerempuan,
  ]);

  const validate = () => {
    let newError = {};

    const kelahiran = parseInt(value.kelahiran) || 0;
    const lahirLaki = parseInt(value.lahir_hidup_laki_laki) || 0;
    const lahirPerempuan = parseInt(value.lahir_hidup_perempuan) || 0;
    const hidupLaki = parseInt(value.masih_hidup_laki_laki) || 0;
    const hidupPerempuan = parseInt(value.masih_hidup_perempuan) || 0;

    if (!value.kelahiran) {
      newError.kelahiran = "Jumlah kelahiran wajib diisi";
    } else if (!isNumeric(value.kelahiran)) {
      newError.kelahiran = "Jumlah kelahiran tidak valid";
    }

    if (
      lahirLaki + lahirPerempuan < kelahiran &&
      (!value.lahir_hidup_laki_laki || value.lahir_hidup_laki_laki === "")
    ) {
      newError.lahir_hidup_laki_laki = "Jumlah Laki-laki wajib diisi";
    } else if (
      value.lahir_hidup_laki_laki !== undefined &&
      value.lahir_hidup_laki_laki !== "" &&
      !isNumeric(value.lahir_hidup_laki_laki)
    ) {
      newError.lahir_hidup_laki_laki = "Jumlah Laki-laki tidak valid";
    }

    if (
      lahirLaki + lahirPerempuan < kelahiran &&
      (!value.lahir_hidup_perempuan || value.lahir_hidup_perempuan === "")
    ) {
      newError.lahir_hidup_perempuan = "Jumlah Perempuan wajib diisi";
    } else if (
      value.lahir_hidup_perempuan !== undefined &&
      value.lahir_hidup_perempuan !== "" &&
      !isNumeric(value.lahir_hidup_perempuan)
    ) {
      newError.lahir_hidup_perempuan = "Jumlah Perempuan tidak valid";
    }

    if (lahirLaki + lahirPerempuan !== kelahiran) {
      newError.lahir_hidup_laki_laki =
        "Jumlah anak lahir hidup (laki-laki + perempuan) harus sama dengan jumlah kelahiran";
      newError.lahir_hidup_perempuan =
        "Jumlah anak lahir hidup (laki-laki + perempuan) harus sama dengan jumlah kelahiran";
    }

    if (hidupLaki > lahirLaki) {
      newError.masih_hidup_laki_laki =
        "Jumlah anak laki-laki masih hidup tidak boleh lebih dari jumlah lahir hidup";
    }

    if (hidupPerempuan > lahirPerempuan) {
      newError.masih_hidup_perempuan =
        "Jumlah anak perempuan masih hidup tidak boleh lebih dari jumlah lahir hidup";
    }

    if (kelahiran < 0)
      newError.kelahiran = "Jumlah kelahiran tidak boleh negatif";
    if (lahirLaki < 0)
      newError.lahir_hidup_laki_laki = "Jumlah tidak boleh negatif";
    if (lahirPerempuan < 0)
      newError.lahir_hidup_perempuan = "Jumlah tidak boleh negatif";
    if (hidupLaki < 0)
      newError.masih_hidup_laki_laki = "Jumlah tidak boleh negatif";
    if (hidupPerempuan < 0)
      newError.masih_hidup_perempuan = "Jumlah tidak boleh negatif";

    let countJumlahAnakKandung = 0;
    let countJumlahAnakKandungLaki = 0;
    let countJumlahAnakKandungPerempuan = 0;
    let newKeluarga = Object.keys(keluarga).map((key) => keluarga[key]);

    newKeluarga.forEach((el) => {
      if (el.kd_ibukandung === "2" || el.kd_ibukandung === "1") {
        countJumlahAnakKandung = countJumlahAnakKandung + 1;
        if (el.jenis_kelamin === "1") {
          countJumlahAnakKandungLaki = countJumlahAnakKandungLaki + 1;
        } else {
          countJumlahAnakKandungPerempuan = countJumlahAnakKandungPerempuan + 1;
        }
      }
    });
    // console.log("newKeluarga", newKeluarga)

    let arrAnakKandung = newKeluarga.filter(
      (el) => el.sts_hubungan === "3" && ["1", "2"].includes(el.kd_ibukandung)
    );
    let arrDate = [];
    arrAnakKandung.forEach((el) => {
      const dateParts = el.tgl_lahir.split("-");
      const tglLahir = new Date(
        +dateParts[2],
        +dateParts[1] - 1,
        +dateParts[0]
      );
      const usiaHari = countDays(tglLahir);
      arrDate = arrDate.concat({
        nama: el.nama_anggotakel,
        usiaHari: usiaHari,
      });
    });
    const shortArr = arrDate.sort((a, b) => {
      return a.usiaHari - b.usiaHari;
    });

    let dataKembar = [];
    for (let i = 0; i < shortArr.length; i++) {
      for (let j = i + 1; j < shortArr.length; j++) {
        const selisih = Math.abs(shortArr[i].usiaHari - shortArr[j].usiaHari);
        if (selisih <= 30) {
          if (!dataKembar.includes(shortArr[i].nama)) {
            dataKembar.push(shortArr[i].nama);
          }
          if (!dataKembar.includes(shortArr[j].nama)) {
            dataKembar.push(shortArr[j].nama);
          }
        }
      }
    }

    // if (
    //   value.lahir_hidup_laki_laki &&
    //   parseInt(value.lahir_hidup_laki_laki) < countJumlahAnakKandungLaki
    // ) {
    //   newError.lahir_hidup_laki_laki =
    //     "Jumlah anak lahir hidup lebih sedikit dari anak kandung";
    // }
    // if (
    //   value.lahir_hidup_perempuan &&
    //   parseInt(value.lahir_hidup_perempuan) < countJumlahAnakKandungPerempuan
    // ) {
    //   newError.lahir_hidup_perempuan =
    //     "Jumlah anak lahir hidup lebih sedikit dari anak kandung";
    // }

    // if (
    //   value.masih_hidup_laki_laki &&
    //   parseInt(value.masih_hidup_laki_laki) < countJumlahAnakKandungLaki
    // ) {
    //   newError.masih_hidup_laki_laki =
    //     "Jumlah anak masih hidup lebih sedikit dari anak kandung";
    // }
    // if (
    //   value.masih_hidup_perempuan &&
    //   parseInt(value.masih_hidup_perempuan) < countJumlahAnakKandungPerempuan
    // ) {
    //   newError.masih_hidup_perempuan =
    //     "Jumlah anak masih hidup lebih sedikit dari anak kandung";
    // }

    if (
      dataKembar.length > 0 &&
      value.kelahiran < countJumlahAnakKandung - dataKembar.length + 1
    ) {
      newError.kelahiran =
        "Jumlah ibu melahirkan tidak sesuai dengan data anak kandung pada form keluarga (total anak kandung " +
        countJumlahAnakKandung +
        " dan terdapat " +
        dataKembar.length +
        " anak kembar)";
    }
    if (dataKembar.length == 0 && value.kelahiran < countJumlahAnakKandung) {
      newError.kelahiran =
        "Jumlah ibu melahirkan tidak sesuai dengan data anak kandung pada form keluarga (total anak kandung " +
        countJumlahAnakKandung +
        ")";
    }

    return newError;
  };

  const countDays = (tanggal) => {
    const dateA = moment();
    const dateB = moment(tanggal);
    const days = dateA.diff(dateB, "days", true);
    return parseInt(days);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const findErrors = validate();

    const errorValues = Object.values(findErrors);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      let normalizeValue = {
        _id: `${no_kk}${id}`,
        Pertanyaan: pertanyaan,
        Jawaban_H1: value.kelahiran,
        Jawaban_H2: 0,
        Jawaban_HDate1: "",
        Jawaban_HDate2: "",
        No_Pertanyaan: 1,
        No_KK: no_kk,
        answer: [
          {
            _id: `${no_kk}${id}01`,
            No_Jawaban: 1,
            // Jawaban_D1: parseInt(value.lahir_hidup_laki_laki),
            // Jawaban_D2: parseInt(value.lahir_hidup_perempuan),
            Jawaban_D1: value.lahir_hidup_laki_laki,
            Jawaban_D2: value.lahir_hidup_perempuan,
            Jawab_D3: 0,
            Jawab_D4: 0,
            pilihankb: 0,
            Lainnya: "",
          },
          {
            _id: `${no_kk}${id}02`,
            No_Jawaban: 2,
            // Jawaban_D1: parseInt(value.masih_hidup_laki_laki),
            // Jawaban_D2: parseInt(value.masih_hidup_perempuan),
            Jawaban_D1: value.masih_hidup_laki_laki,
            Jawaban_D2: value.masih_hidup_perempuan,
            Jawab_D3: 0,
            Jawab_D4: 0,
            pilihankb: 0,
            Lainnya: "",
          },
        ],
      };
      if (value._rev) {
        normalizeValue._rev = value._rev;
      }

      saveValue(normalizeValue);
      // console.log("NORMALIZE VALUE KB N0.1 >>>>> ", normalizeValue)
    }
  };

  return (
    <>
      <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <Typography margin="normal" paragraph>
              <span className={classes.badge}>01</span>
              {pertanyaan}
            </Typography>

            <div style={{ position: "absolute", right: "0", top: "58px" }}>
              <InfoButton
                content={
                  "Jumlah kelahiran adalah jumlah seluruh kelahiran yang dialami responden sampai saat wawancara (tanpa memperhatikan siapa ayah mereka)." +
                  "\nKelahiran kembar dihitung sebagai 1 (satu) kelahiran." +
                  "\n\nBerapa jumlah anak lahir hidup" +
                  "\nJumlah anak lahir hidup adalah jumlah anak yang dilahirkan hidup, baik yang saat ini tinggal bersama ataupun tidak tinggal bersama responden, maupun anak yang telah meninggal. " +
                  "\n\nBerapa jumlah anak masih hidup" +
                  "\nJumlah anak masih hidup adalah jumlah anak yang masih hidup dari total kelahiran hidup, baik yang saat ini tinggal bersama ataupun tidak tinggal bersama responden."
                }
              />
            </div>
          </div>
          <div className={classes.cardBody}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  variant="outlined"
                  id="kelahiran"
                  name="kelahiran"
                  value={value.kelahiran || kelahiran}
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        className={classes.inputAdornmentNoWrap}
                        position="end"
                      >
                        Kelahiran
                      </InputAdornment>
                    ),
                  }}
                  type="number"
                  inputProps={{
                    className: classes.inputMini,
                    min: 0,
                    maxLength: 2,
                  }}
                  error={error.kelahiran ? true : false}
                  helperText={error.kelahiran}
                />
              </Grid>
              {value.kelahiran?.length > 0 && value.kelahiran > 0 && (
                <>
                  <Grid item xs={12} md={12}>
                    <Typography>1. Berapa jumlah anak lahir hidup</Typography>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      id="lahir_hidup_laki_laki"
                      name="lahir_hidup_laki_laki"
                      value={value.lahir_hidup_laki_laki || lahirHidupLaki}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            className={classes.inputAdornmentNoWrap}
                            position="start"
                          >
                            Laki-laki:
                          </InputAdornment>
                        ),
                      }}
                      type="number"
                      inputProps={{
                        className: classes.inputMini,
                        min: 0,
                        max: value.kelahiran,
                        maxLength: 2,
                      }}
                      error={error.lahir_hidup_laki_laki ? true : false}
                      helperText={error.lahir_hidup_laki_laki}
                      disabled={value.kelahiran === "0" ? true : false}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      id="lahir_hidup_perempuan"
                      name="lahir_hidup_perempuan"
                      value={value.lahir_hidup_perempuan || lahirHidupPerempuan}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            className={classes.inputAdornmentNoWrap}
                            position="start"
                          >
                            Perempuan:
                          </InputAdornment>
                        ),
                      }}
                      type="number"
                      inputProps={{
                        className: classes.inputMini,
                        min: 0,
                        max: value.kelahiran,
                        maxLength: 2,
                      }}
                      error={error.lahir_hidup_perempuan ? true : false}
                      helperText={error.lahir_hidup_perempuan}
                      disabled={value.kelahiran === "0" ? true : false}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>2. Berapa jumlah anak masih hidup</Typography>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      id="masih_hidup_laki_laki"
                      name="masih_hidup_laki_laki"
                      value={value.masih_hidup_laki_laki || masihHidupLaki}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            className={classes.inputAdornmentNoWrap}
                            position="start"
                          >
                            Laki-laki:
                          </InputAdornment>
                        ),
                      }}
                      type="number"
                      inputProps={{
                        className: classes.inputMini,
                        min: 0,
                        max: value.lahir_hidup_laki_laki,
                        maxLength: 2,
                      }}
                      error={error.masih_hidup_laki_laki ? true : false}
                      helperText={error.masih_hidup_laki_laki}
                      disabled={value.kelahiran === "0" ? true : false}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      id="masih_hidup_perempuan"
                      name="masih_hidup_perempuan"
                      value={value.masih_hidup_perempuan || masihHidupPerempuan}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            className={classes.inputAdornmentNoWrap}
                            position="start"
                          >
                            Perempuan:
                          </InputAdornment>
                        ),
                      }}
                      type="number"
                      inputProps={{
                        className: classes.inputMini,
                        min: 0,
                        max: value.lahir_hidup_perempuan,
                        maxLength: 2,
                      }}
                      error={error.masih_hidup_perempuan ? true : false}
                      helperText={error.masih_hidup_perempuan}
                      disabled={value.kelahiran === "0" ? true : false}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </div>
        </div>
      </form>

      <Grid item xs style={{ marginTop: 20 }}>
        <Button
          ref={backRef}
          // disabled={!isSomethingChange || isSubmitting}
          onClick={handleBackSub}
        >
          <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
        </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
          style={{ float: "right" }}
          ref={nextRef}
          form={id}
          disabled={isSubmitting}
          type="submit"
        >
          Selanjutnya <ChevronRight className={classes.iconRight} />
        </Button>
      </Grid>
    </>
  );
}

export default SubForm01;
